import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import EmailAddress from "_shared/email-addresses/email-address";
import Guid from "_shared/guids/guid";
import Name from "_shared/names/name";
import UserProfileSchema, {
  UserProfileJSON,
  UserProfileParams,
} from "users/information/profile-information/user-profile-schema";

export default class UserProfile {
  public static readonly EXAMPLE = UserProfile.create({
    id: Guid.generate(),
    name: Name.create({ params: { firstName: "John", lastName: "Doe" } }),
    email: EmailAddress.create("john.doe@example.com"),
    isClientRep: false,
    isVendorRep: false,
  });

  public static create(values: UserProfileParams): UserProfile {
    const parsed = UserProfileSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid UserProfile parameters.");
    }
    return new UserProfile(parsed);
  }

  public static fromJSON(json: UserProfileJSON): UserProfile {
    if (isNullOrUndefined(json)) return json;
    const params = UserProfileSchema.deserialize(json);
    return new UserProfile(params);
  }

  public readonly id: Guid;
  public readonly name: Name;
  public readonly email: EmailAddress | null | undefined;
  public readonly isClientRep: boolean;
  public readonly isVendorRep: boolean;

  public constructor(params: UserProfileParams) {
    this.id = params.id;
    this.name = params.name;
    this.email = params.email;
    this.isClientRep = params.isClientRep;
    this.isVendorRep = params.isVendorRep;
  }

  public toJSON(): UserProfileJSON {
    return UserProfileSchema.serialize(this);
  }

  public isEqualTo(other: UserProfile): boolean {
    return this.id.isEqualTo(other?.id);
  }

  public toString(): string {
    return `UserProfile (
      id: ${this.id.value}
      name: ${this.name.toString()}
      email: ${this.email?.toString() ?? "N/A"}
      isClientRep: ${this.isClientRep}
      isVendorRep: ${this.isVendorRep}
    )`;
  }
}
